import Spinner from "./Spinner.jsx";

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/spinner/index.js